import React from 'react'
import styled from 'styled-components'

const ItineraryWrapper = styled.section`
  position: relative;
`

const ItineraryTimeline = styled.div`
  position: relative;
`

const ItineraryItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-bottom: 1.5rem;

  &:last-child {
    padding-bottom: 0;
  }
`

const ItineraryMarkerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 1.2rem;

  &::after {
    content: '';
    position: absolute;
    top: 1.2rem;
    bottom: -1.5rem;
    width: 2px;
    background-color: rgba(var(--bs-primary-rgb), 0.25);
  }

  ${ItineraryItem}:last-child &::after {
    display: none;
  }
`

const ItineraryMarker = styled.div`
  position: relative;
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 1.2rem;
  height: 1.2rem;

  border: 2px solid var(--bs-primary);
  border-radius: 50%;

  background-color: var(--bs-body-bg);

  &::after {
    content: '';
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    background-color: var(--bs-primary);
  }
`

const ItineraryContent = styled.div`
  flex: 1;
  line-height: 1.5;
  color: var(--bs-body-color);
`

const Itinerary = ({ itinerary }) => {
  let itineraryArray = []

  try {
    itineraryArray = typeof itinerary === 'string'
      ? JSON.parse(itinerary)
      : itinerary
  } catch (error) {
    console.error('Invalid itinerary JSON:', error)
    return null
  }

  if (!Array.isArray(itineraryArray)) {
    return null
  }

  const validItinerary = itineraryArray.filter(
    (item) => typeof item === 'string' && item.trim()
  )

  if (validItinerary.length === 0) {
    return null
  }

  return (
    <ItineraryWrapper className="itinerary">
      <ItineraryTimeline>
        {validItinerary.map((item, index) => (
          <ItineraryItem key={index}>
            <ItineraryMarkerWrapper>
              <ItineraryMarker aria-hidden="true" />
            </ItineraryMarkerWrapper>

            <ItineraryContent>
              {item}
            </ItineraryContent>
          </ItineraryItem>
        ))}
      </ItineraryTimeline>
    </ItineraryWrapper>
  )
}

export default Itinerary
